export default function isSelenium() {
  return document.cookie.split('; ').some(cookie => cookie.startsWith('hs_selenium='));
}